export default {"src":"/_next/static/media/wish_list_empty.e4521845.svg","height":150,"width":220};